import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { UpdateContext } from "../../../main-context";
import Spinner from "../Spinner";
import wizard_css from "../../inspection.module.css";
import { v4 as uuidv4 } from "uuid";
import { deleteSaveFromDatabase } from "../../../lib/comm";

export default function CheckList({
  check,
  topLevel,
  deleteComment,
  saveTextCommentAndPhoto,
  index,
  setCheckValue,
  type,
}) {
  const files = useRef();
  const update_context = useContext(UpdateContext);
  const [newValue, set_newValue] = useState("");
  const [doneLoading, set_doneLoading] = useState(undefined);
  const [showSpinner, set_showSpinner] = useState(false);
  const [photo, set_photo] = useState(null);

  useEffect(() => {
    if (!check.value) {
      setCheckValue([], check.id, topLevel);
    }
  }, [check.id, check.value, index, setCheckValue, topLevel]);

  const shouldHide = useCallback(
    (item) => {
      if (+item.open !== 1 && type === "daily") {
        if (
          update_context.time_zone.localDate(item.updated) !==
          update_context.time_zone.getDate()
        ) {
          return true;
        }
      }

      return false;
    },
    [type, update_context.time_zone]
  );

  const deleteCommentFunc = useCallback(
    (id) => {
      return deleteComment({ id });
    },
    [deleteComment]
  );

  const findRelevantCheckValue = useCallback(
    (savedCheckValues) => {
      var filtered = savedCheckValues.filter((item) => {
        return item.equipment_check_id === check.id;
      });

      if (filtered.length !== 1) {
        alert("error no check values saved");
      }

      return filtered[0];
    },
    [check.id]
  );

  const addValue = useCallback(
    (event) => {
      event.preventDefault();
      const ident = uuidv4();
      if (newValue) {
        set_doneLoading(undefined);
        set_showSpinner(true);
        saveTextCommentAndPhoto({
          comment: newValue,
          photo,
          id: check.id,
          ident: ident,
        }).then((savedCheckValues) => {
          // post here and only push when done.

          if (savedCheckValues !== "comm error") {
            const value = [...check.value];
            if (savedCheckValues === true) {
              value.unshift({
                comment: newValue,
                photo: photo,
                check_value_id: null,
                ident: ident,
              });
            } else {
              var relevantCheckValue = findRelevantCheckValue(savedCheckValues);
              value.unshift({
                comment: newValue,
                photo: relevantCheckValue.photo,
                check_value_id: relevantCheckValue.check_value_id,
              });
            }

            setCheckValue(value, check.id, topLevel);
          }
          set_newValue("");
          set_photo(null);
          set_doneLoading(true);
          set_showSpinner(false);

          files.current.value = null;
        });
      }
    },
    [
      check.id,
      check.value,
      findRelevantCheckValue,
      newValue,
      photo,
      saveTextCommentAndPhoto,
      setCheckValue,
      topLevel,
    ]
  );

  const processRemove = useCallback(
    (index, check_id, topLevel) => {
      const value_copy = [...check.value];
      value_copy.splice(index, 1);
      setCheckValue(value_copy, check_id, topLevel);
    },
    [check.value, setCheckValue]
  );

  const removeValue = useCallback(
    (index, value) => {
      if (value.ident) {
        deleteSaveFromDatabase(value.ident, update_context).then((res) => {
          if (res === true) {
            processRemove(index, check.id, topLevel);
          }
        });
      } else {
        deleteCommentFunc(value.check_value_id).then(function (res) {
          if (res !== "comm error") {
            processRemove(index, check.id, topLevel);
          }
        });
      }
    },
    [check.id, deleteCommentFunc, processRemove, topLevel, update_context]
  );

  const setPhoto = useCallback((elem) => {
    if (elem.files && elem.files[0]) {
      var fr = new FileReader();
      fr.onload = function (e) {
        set_photo(e.target.result);
      };
      fr.readAsDataURL(elem.files[0]);
    }
  }, []);

  return (
    <UpdateContext.Consumer>
      {({ time_zone }) => (
        <span className={wizard_css["check-list"]}>
          <h3>{check.title}</h3>
          <form
            onSubmit={(event) => addValue(event)}
            className="btn btn-default multi-check-list-form"
          >
            <input
              placeholder="Add new comment"
              type="text"
              value={newValue}
              onChange={(event) => set_newValue(event.target.value)}
            />{" "}
            <input
              ref={(ref) => (files.current = ref)}
              type="file"
              onChange={(event) => setPhoto(event.target)} // TODO CHECK
              capture="camera"
              accept="image/*"
            />
            <button
              type="submit"
              className={`btn ${
                newValue && !showSpinner // TODO CHECK && !message
                  ? "btn-success active"
                  : "btn-success disabled"
              }`}
              style={{ position: "relative" }}
            >
              <span className="fa fa-check"></span>
            </button>
            {!!showSpinner && (
              <Spinner
                waitfor={doneLoading}
                className={"spin-loader"}
              ></Spinner>
            )}
          </form>
          {(!!check.values.length || !!check.value.length) && (
            <h3 className="text-danger">Open Items</h3>
          )}
          {check.values.map((item, index) => (
            <ul key={index}>
              <li className={shouldHide(item) ? "hidden-item" : ""}>
                <span className={+item.open === 0 ? "closed-item" : ""}>
                  <time>{time_zone.localFormat(item.time)}</time>{" "}
                  <span>{item.value}</span> <em>{item.user}</em>{" "}
                  {!!item.photo && (
                    <a
                      href={item.photo}
                      data-lightbox={check.title}
                      style={{ fontWeight: "normal" }}
                    >
                      view image
                    </a>
                  )}
                </span>
                {"" + item.closedItemComment !== "" && (
                  <span className={wizard_css["corrective-action"]}>
                    Corrective Action:
                    <i>{item.closedItemComment}</i>
                    {"" + item.closedItemPhoto !== "" && (
                      <a
                        href={item.closedItemPhoto}
                        data-lightbox={check.title}
                      >
                        view image
                      </a>
                    )}
                  </span>
                )}
                {!!item.status && (
                  <span style={{ color: "black", fontWeight: "normal" }}>
                    Status:
                    <i>{item.status}</i>
                  </span>
                )}
              </li>
            </ul>
          ))}
          {/* <!-- the newly added comments will appear below. these are the only ones you can delete.  --> */}
          {check.value.map((value, index) => (
            <ul key={index}>
              <li>
                <span>{value.comment}</span>{" "}
                {!!value.photo && (
                  <a
                    href={value.photo}
                    data-lightbox={check.title}
                    style={{ fontWeight: "normal" }}
                  >
                    view image
                  </a>
                )}{" "}
                {!value.locked && (
                  <span onClick={() => removeValue(index, value)}>
                    <span className="fa fa-times"></span>
                  </span>
                )}
              </li>
            </ul>
          ))}
        </span>
      )}
    </UpdateContext.Consumer>
  );
}
